// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// Selectirs
// tslint:disable-next-line: max-line-length
import { selectTrainingDocumentsPageLoading, selectTrainingDocumentsShowInitWaitingMessage, selectTrainingDocumentsQueryResult } from '../_selectors/training-document.selectors';

export class TrainingDocumentsDataSource extends BaseDataSource {
    trashed = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectTrainingDocumentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectTrainingDocumentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectTrainingDocumentsQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
